const { styled } = require('styled-components');

export const Section = styled.div`
  background-color: transparent;
`;
